import { render } from "./NatalContent.vue?vue&type=template&id=886f8de0&scoped=true"
import script from "./NatalContent.vue?vue&type=script&lang=js"
export * from "./NatalContent.vue?vue&type=script&lang=js"

import "./NatalContent.vue?vue&type=style&index=0&id=886f8de0&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src310475096/src/AstopiaAdminPanel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-886f8de0"]])

export default __exports__